<p-tabView (onChange)="onTabChange($event)" [ngClass]="{'gltab': visibleFromModule != 'Finance'}">
    <p-tabPanel header="Overview">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px">
                        <h6 class="p-mb-0">Billing:</h6>
                        <span *ngIf="cmDetails">
                            <p class="p-mb-0">
                                <span *ngIf="templates?.labels_billaddress[5]?.isChecked">
                                    {{ cmDetails?.account?.sequenceNumber ? (cmDetails?.account?.sequenceNumber
                                    + ' - ') : ""}}
                                </span>
                                <span class="p-mb-0 acc-name-popup-link" (click)="onAccountViewClick(cmDetails)"
                                    *ngIf="templates?.labels_billaddress[0]?.isChecked">
                                    {{ cmDetails?.account?.businessName }}
                                </span>
                            </p>
                            <!-- Street -->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[1]?.isChecked">
                                {{ billingAddress?.address?.streetAddress1 }}
                                <span
                                    *ngIf="billingAddress?.address && billingAddress?.address?.streetAddress1 && billingAddress?.address?.streetAddress1 != '' && billingAddress?.address?.streetAddress2 && billingAddress?.address?.streetAddress2 != ''">,</span>
                                {{ billingAddress?.address?.streetAddress2 }}
                            </p>
                            <!--Address-->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[2]?.isChecked">
                                {{ billingAddress?.address?.city?.name }}
                                <span
                                    *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.name && billingAddress?.address?.city?.name != '' && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.name != ''">,</span>
                                {{ billingAddress?.address?.city?.state?.name }}
                                <span
                                    *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.name && billingAddress?.address?.city?.state?.name != '' && billingAddress?.address?.city?.state?.country && billingAddress?.address?.city?.state?.country?.name != ''">,</span>
                                {{ billingAddress?.address?.city?.state?.country?.name }}
                                <span
                                    *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.country && billingAddress?.address?.city?.state?.country?.name && billingAddress?.address?.city?.state?.country?.name != '' && billingAddress?.address?.zipCode && billingAddress?.address?.zipCode != ''">,</span>
                                {{ billingAddress?.address?.zipCode }}
                            </p>
                            <!--billing contact-->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[3]?.isChecked">
                                {{ billingAddressContact?.firstName }}
                                {{ billingAddressContact?.lastName ? " " : "" }}
                                {{ billingAddressContact?.lastName }}
                            </p>
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[4]?.isChecked">
                                {{ billingAddressContact && billingAddressContact?.contactPhones &&
                                billingAddressContact?.contactPhones[0]?.phone &&
                                billingAddressContact?.contactPhones[0]?.phone?.number ?
                                billingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                            </p>
                        </span>
                        <ng-container
                            *ngIf="customFields?.billing_address_item && customFields?.billing_address_item?.length > 0">
                            <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                                [customFieldData]="customFields.billing_address_item"></app-custom-attribute-overview>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px">
                        <h6 class="p-mb-0">Shipping</h6>
                        <span *ngIf="cmDetails">
                            <p class="p-mb-0">
                                <span *ngIf="templates?.labels_shipaddress[5]?.isChecked">
                                    {{ cmDetails?.account?.sequenceNumber ? (cmDetails?.account?.sequenceNumber + ' - ') : ""}}
                                </span>
                                <!-- <span class="p-mb-0 acc-name-popup-link" (click)="onAccountViewClick(cmDetails)"
                                    *ngIf="templates?.labels_shipaddress[0]?.isChecked">
                                    {{ cmDetails?.account?.businessName }}
                                </span> -->
                                <span class="p-mb-0 acc-name-popup-link" *ngIf="templates?.labels_shipaddress[0]?.isChecked">
                                    {{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : cmDetails?.account?.businessName }}
                                </span>
                            </p>
                            <!-- Street -->
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress[1]?.isChecked">
                                {{ shippingAddress?.address?.streetAddress1 }}
                                <span
                                    *ngIf="shippingAddress?.address && shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1 != '' && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2 != ''">,</span>
                                {{ shippingAddress?.address?.streetAddress2 }}
                            </p>
                            <!--Address-->
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress[2]?.isChecked">
                                {{ shippingAddress?.address?.city?.name }}
                                <span
                                    *ngIf="shippingAddress?.address && shippingAddress?.address?.city && shippingAddress?.address?.city?.name && shippingAddress?.address?.city?.name != '' && shippingAddress?.address?.city?.state && shippingAddress?.address?.city?.state?.name != ''">,</span>
                                {{ shippingAddress?.address?.city?.state?.name }}
                                <span
                                    *ngIf="shippingAddress?.address && shippingAddress?.address?.city && shippingAddress?.address?.city?.state && shippingAddress?.address?.city?.state?.name && shippingAddress?.address?.city?.state?.name != '' && shippingAddress?.address?.city?.state?.country && shippingAddress?.address?.city?.state?.country?.name != ''">,</span>
                                {{ shippingAddress?.address?.city?.state?.country?.name }}
                                <span
                                    *ngIf="shippingAddress?.address && shippingAddress?.address?.city && shippingAddress?.address?.city?.state && shippingAddress?.address?.city?.state?.country && shippingAddress?.address?.city?.state?.country?.name && shippingAddress?.address?.city?.state?.country?.name != '' && shippingAddress?.address?.zipCode && shippingAddress?.address?.zipCode != ''">,</span>
                                {{ shippingAddress?.address?.zipCode }}
                            </p>
                            <!--shipping contact-->
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress[3]?.isChecked">
                                {{ shippingAddressContact?.firstName }}
                                {{ shippingAddressContact?.lastName ? " " : "" }}
                                {{ shippingAddressContact?.lastName }}
                            </p>
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress[4]?.isChecked">
                                {{ shippingAddressContact && shippingAddressContact?.contactPhones &&
                                shippingAddressContact?.contactPhones[0]?.phone &&
                                shippingAddressContact?.contactPhones[0]?.phone?.number ?
                                shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                            </p>
                        </span>
                        <ng-container
                            *ngIf="customFields?.shipping_address_item && customFields?.shipping_address_item?.length > 0">
                            <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                                [customFieldData]="customFields.shipping_address_item"></app-custom-attribute-overview>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px">
                        <span style="float: right" class="btnBars p-mr-0" (click)="showWriteCheck()" *ngIf="writeCheckOptionFor.includes(cmDetails?.creditMemoStatusId)">
                            <i class="pi pi-plus-circle" tooltipPosition="left" pTooltip="Pay Credit Memo"></i>
                        </span>
                        <span style="float: right; color: #ce1800" *ngIf="showCreditVoidMsg"
                            pTooltip="on {{ voidDate }} <br/>by {{ app.user.userName }}" tooltipPosition="top" [escape]="false">
                            Voided </span>
                        <p class="p-mb-0" style="margin-top: 13px" *ngIf="templates?.labels_misc[0]?.isChecked">
                            {{ templates?.labels_misc[0]?.labelname }}:
                            <span>{{ cmDetails?.creditMemoDate | date: "MM/dd/yyyy" }}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="isAllowPostingPeriod">
                            <span>Posting Period:{{ cmDetails?.postingDate  | date: 'MMMM yyyy' }}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="templates?.labels_misc[1]?.isChecked">
                            {{ templates?.labels_misc[1]?.labelname }}:
                            <span>{{ cmDetails?.expiryDate | date: "MM/dd/yyyy" }}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="templates?.labels_misc[2]?.isChecked">
                            {{ templates?.labels_misc[2]?.labelname }}:
                            {{ cmDetails?.creditMemoStatus }}
                        </p>
                        <p class="p-mb-0" *ngIf="templates?.labels_misc[3]?.isChecked">
                            {{ templates?.labels_misc[3]?.labelname }}:
                            {{ cmDetails?.createdByUser }}
                        </p>
                        <p class="p-mb-0" *ngIf="templates?.labels_misc[4]?.isChecked">
                            {{ templates?.labels_misc[4]?.labelname }}:
                            {{ cmDetails?.number }}
                        </p>
                        <p class="p-mb-0" *ngIf="templates?.labels_misc[5]?.isChecked">
                            {{ templates?.labels_misc[5]?.labelname }}:
                            {{ cmDetails?.warehouse?.locationId }}
                        </p>
                        <!-- Currency: -->
                        <p class="p-mb-0" *ngIf="templates?.labels_misc[6]?.isChecked && (baseCurrency?.currencyId !== cmDetails?.account?.currencyId)">
                            {{ templates?.labels_misc[6]?.labelname }}: 
                            <span>1 {{ baseCurrency?.code }} = {{ cmDetails?.exchangeRate }} {{ cmDetails?.account?.currencyUnit?.code }}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="templates?.labels_misc[7]?.isChecked && cmDetails?.rmaNumber">
                            {{ templates?.labels_misc[7]?.labelname }}:
                            {{ cmDetails?.rmaNumber ?? "" }}
                        </p>
        
                        <ng-container *ngIf="customFields?.misc_item && customFields?.misc_item?.length > 0">
                            <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                                [customFieldData]="customFields?.misc_item"></app-custom-attribute-overview>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="p-field p-formgrid p-grid">
            <div class="p-col" *ngIf="templates?.labels_section[0]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[0]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ cmDetails?.paymentTerm?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[1]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[1]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ cmDetails?.paymentMethod?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[2]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[2]?.labelname }}
                    </h6>
                    {{ cmDetails?.shippingTerm?.name }}
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[3]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[3]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ cmDetails?.shippingMethod?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[4]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[4]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ cmDetails?.user?.name }}
                    </p>
                </div>
            </div>
            <ng-container *ngIf="customFields?.section_item && customFields?.section_item?.length > 0">
                <app-custom-attribute-overview [fieldType]="fieldTypes.SECTION"
                    [customFieldData]="customFields.section_item"></app-custom-attribute-overview>
            </ng-container>
        </div>
        
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p-table [value]="purchaseList" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="id">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 5rem"></th>
                            <th *ngIf="templates?.labels_table[0]?.isChecked">
                                {{ templates?.labels_table[0]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[1]?.isChecked" style="width: 400px">
                                {{ templates?.labels_table[1]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[2]?.isChecked">
                                {{ templates?.labels_table[2]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[3]?.isChecked">
                                {{ templates?.labels_table[3]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[10]?.isChecked">
                                {{ templates?.labels_table[10]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[11]?.isChecked">
                                {{ templates?.labels_table[11]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[4]?.isChecked">
                                {{ templates?.labels_table[4]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[8]?.isChecked">
                                {{ templates?.labels_table[8]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[6]?.isChecked">
                                {{ templates?.labels_table[6]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[5]?.isChecked">
                                {{ templates?.labels_table[5]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[9]?.isChecked">
                                {{ templates?.labels_table[9]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[7]?.isChecked">
                                {{ templates?.labels_table[7]?.labelname }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-index="rowIndex" let-expanded="expanded">
                        <tr>
                            <td>
                                <button type="button" pButton pRipple [pRowToggler]="product"
                                    class="p-button-text p-button-rounded p-button-plain"
                                    *ngIf="product?.creditMemoBundleDetail?.length > 0"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                            </td>
                            <td *ngIf="templates?.labels_table[0]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.itemNo ? product.itemNo : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[1]?.isChecked">
                                <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                    <ng-template pTemplate="output">
                                        {{ product.description ? (product.description | shorten: 55) : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[2]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.qty ? (product.qty | customNumberFormat: qtyFractionDigits) : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[3]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.uom ? product.uom : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[10]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.costPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[11]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.totalCostPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[4]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.rate | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[8]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.subTotal | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[6]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        <span *ngIf="product?.discountPercentage && product?.discountPercentage > 0">
                                            ({{ product?.discountPercentage }}%)
                                        </span>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[5]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[9]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }} {{ product?.additionalFeesType == 'Percentage' && product?.additionalRate && product?.additionalRate > 0 ? '(' + product?.additionalRate + ')%' : '' }}
        
        
                                        <!-- <span *ngIf="product?.additionalFeesType == 'Amount' && product?.additionalAmount && product?.additionalAmount > 0">
                                            {{ product.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </span>
                                    <span *ngIf="product?.additionalFeesType == 'Percentage' && product?.additionalRate && product?.additionalRate > 0"> 
                                        {{ product.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}({{ product?.additionalRate }}%) 
                                    </span> -->
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[7]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.amount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-product>
                        <ng-container *ngFor="let bundleProduct of product?.creditMemoBundleDetail">
                            <!-- bundle items -->
                            <tr class="bundleRow">
                                <td class="action">
                                    <button type="button" pButton pRipple
                                        *ngIf="bundleProduct.creditMemoBundleDetail?.length > 0"
                                        (click)="bundleProduct.show=!bundleProduct.show"
                                        class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                        [icon]="bundleProduct.show ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"> </button>
                                </td>
                                <td *ngIf="templates?.labels_table[0]?.isChecked" style="padding-left: 2rem !important">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.itemNo ? bundleProduct?.itemNo : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[1]?.isChecked">
                                    <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.description ? (bundleProduct?.description | shorten: 55) : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[2]?.isChecked">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.qty ? (bundleProduct?.qty | customNumberFormat: qtyFractionDigits) : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[3]?.isChecked">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.uom ? bundleProduct?.uom : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[10]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.costPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[11]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.totalCostPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[4]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.rate | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[8]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.subTotal | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[6]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                            <span
                                                *ngIf="bundleProduct?.discountPercentage && bundleProduct?.discountPercentage > 0">
                                                ({{ bundleProduct?.discountPercentage }}%)
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[5]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[9]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }} {{ bundleProduct?.additionalFeesType == 'Percentage' && bundleProduct?.additionalRate && bundleProduct?.additionalRate > 0 ? '(' + bundleProduct?.additionalRate + ')%' : '' }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[7]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId!=6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.amount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                            </tr>
                            <ng-container *ngIf="bundleProduct.show">
                                <!-- bundle items -->
                                <tr *ngFor="let kp of bundleProduct.creditMemoBundleDetail" class="bundleRowSub">
                                    <td></td>
                                    <td *ngIf="templates?.labels_table[0]?.isChecked" style="padding-left: 2rem !important">
                                        {{ kp?.itemNo ? kp?.itemNo : null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[1]?.isChecked">
                                        {{ kp?.description ? (kp?.description | shorten: 55) :null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[2]?.isChecked">
                                        {{ kp?.qty ? (kp?.qty | customNumberFormat: qtyFractionDigits) : null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[3]?.isChecked">
                                        {{ kp?.uom ? kp?.uom : null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[10]?.isChecked">
                                    </td>
                                    <td *ngIf="templates?.labels_table[11]?.isChecked">
                                    </td>
                                    <td *ngIf="templates?.labels_table[4]?.isChecked">
                                    </td>
                                    <td *ngIf="templates?.labels_table[8]?.isChecked">
                                    </td>
                                    <td *ngIf="templates?.labels_table[6]?.isChecked">
                                    </td>
                                    <td *ngIf="templates?.labels_table[5]?.isChecked">
                                    </td>
                                    <td *ngIf="templates?.labels_table[9]?.isChecked">
                                    </td>
                                    <td *ngIf="templates?.labels_table[7]?.isChecked">
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td></td>
                            <td class="p-text-left">{{ templates?.labels_footer[0]?.labelname }}</td>
                            <td class="p-text-left"></td>
                            <td *ngIf="templates?.labels_table[2]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[3]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[10]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[11]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[4]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[8]?.isChecked">{{ cmDetails?.totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[6]?.isChecked">{{ cmDetails?.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[5]?.isChecked">{{ cmDetails?.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[9]?.isChecked">{{ productsTotalAdditionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[7]?.isChecked">{{ totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[0]?.isChecked && !templates?.labels_table[8]?.isChecked">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[0]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[0]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[0]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ cmDetails?.totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[1]?.isChecked && !templates?.labels_table[6]?.isChecked">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[1]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[1]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[1]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ cmDetails?.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[2]?.isChecked && !templates?.labels_table[5]?.isChecked">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[2]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[2]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[2]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ cmDetails?.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[7]?.isChecked">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[2]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[2]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[7]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ cmDetails?.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[3]?.isChecked">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[3]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[3]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[3]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ cmDetails?.shippingCharge | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[4]?.isChecked">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[4]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[4]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[4]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ cmDetails?.netAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[5]?.isChecked && cmDetails?.appliedCredit > 0">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[5]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[5]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[5]?.labelname }}
                            </td>
                            <td colspan="1">
                                <span class="p-mb-0 acc-name-popup-link" (click)="onAppliedAmountViewClick(salesOrderDetails)">
                                    {{ cmDetails?.appliedCredit | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                </span>
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[6]?.isChecked">
                            <td colspan="2" class="p-text-left">
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[6]"
                                    [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[6]">
                                </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 2" class="p-text-right"> {{ templates?.labels_footer[6]?.labelname }}
                            </td>
                            <td colspan="1">
                                <span>
                                    {{ cmDetails?.pendingCreditAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : creditMemoDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12">
            <div class="p-fluid">
                <div class="card" style="min-height: 100px">
                    <p class="p-mb-0" *ngIf="templates?.labels_message[0]?.isChecked">
                        <b>{{ templates?.labels_message[0]?.labelname }}:</b>
                        <span>{{ cmDetails?.creditMemoNotes && cmDetails?.creditMemoNotes?.length > 0 ?
                            cmDetails?.creditMemoNotes[cmDetails?.creditMemoNotes?.length - 1]?.note?.comment :
                            "" }}</span>
                    </p>
        
                    <p class="p-mb-0" *ngIf="templates?.labels_message[1]?.isChecked">
                        <!-- <b>{{templates?.labels_message[1]?.labelname}}:</b>
                        <span>{{
                            cmDetails?.creditMemoAudits &&
                            cmDetails?.creditMemoAudits?.length > 0
                            ? cmDetails?.creditMemoAudits[
                            cmDetails?.creditMemoAudits?.length - 1
                            ]?.note?.comment
                            : ""
                            }}</span> -->
        
                        <span>
                            <b style="display: inline">{{ templates?.labels_message[1]?.labelname }}:</b>
                            <span style="display: inline; white-space: normal; max-width: 100%"
                                *ngIf="cmDetails?.creditMemoAudits && cmDetails?.creditMemoAudits?.length > 0">
                                <span
                                    [innerHTML]="getSanitizedHtml(cmDetails?.creditMemoAudits[cmDetails?.creditMemoAudits?.length - 1]?.note?.comment)"></span>
                            </span>
                        </span>
                    </p>
        
                    <ng-container *ngIf="customFields?.message_item && customFields?.message_item?.length > 0">
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                            [customFieldData]="customFields.message_item"></app-custom-attribute-overview>
                    </ng-container>
                </div>
            </div>
        </div>
        <!--Custom section and fields-->
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other1_item && customFields?.other1_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 135px">
                    <h6 class="p-mb-0">{{getFilteredSectionsByType('labels_creditmemo_other1')}}</h6>
        
                    <ng-container *ngIf="customFields?.other1_item && customFields?.other1_item?.length > 0">
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                            [customFieldData]="customFields.other1_item"></app-custom-attribute-overview>
                    </ng-container>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other2_item && customFields?.other2_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 135px">
                    <h6 class="p-mb-0">{{getFilteredSectionsByType('labels_creditmemo_other2')}}</h6>
        
                    <ng-container *ngIf="customFields?.other2_item && customFields?.other2_item?.length > 0">
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                            [customFieldData]="customFields.other2_item"></app-custom-attribute-overview>
                    </ng-container>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other3_item && customFields?.other3_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 135px">
                    <h6 class="p-mb-0">{{getFilteredSectionsByType('labels_creditmemo_other3')}}</h6>
        
                    <ng-container *ngIf="customFields?.other3_item && customFields?.other3_item?.length > 0">
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                            [customFieldData]="customFields.other3_item"></app-custom-attribute-overview>
                    </ng-container>
                </div>
            </div>
        </div>
        
        <app-tracking-details-view [trackingDetails]="trackingDetails" [notMatchedTracking]="notMatchedTrackingDetails"></app-tracking-details-view>
        
        <ng-container *ngIf="cmDetails && displayAppliedAmountViewModal">
            <app-applied-amount-view-modal [id]="cmDetails?.id" [channelName]="soChannel.CREDIT_MEMO"
                [displayAppliedAmountViewModal]="displayAppliedAmountViewModal" [creditMemo]="cmDetails"
                (onClose)="onCloseAppliedAmountModal()"></app-applied-amount-view-modal>
        </ng-container>
        
        
        <ng-container *ngIf="displayWriteCheck && cmDetails">
            <app-write-check [display]="displayWriteCheck" [selectedFinance]="selectedFinance" [creditMemo]="cmDetails" (close)="closeWriteCheck()"></app-write-check>
        </ng-container>
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="creditMemoId" [objectTypeId]="transactionTypeIds.CreditMemo" [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>
